module.exports = __webpack_public_path__ + "static/media/sc8r_15.bd692005.png";